export const PAGE_NUMBER = 'number';
export const PAGE_SIZE = 'size';
export const PAGE_TOTAL_ELEMENTS = 'totalElements';
export const PAGE_TOTAL_PAGES = 'totalPages';

export class Page {
  constructor(rawData = {}) {
    this.rawData = {...rawData};
  }

  getNumber() {
    return this.rawData[PAGE_NUMBER] || 0;
  }

  getSize() {
    return this.rawData[PAGE_SIZE] || 0;
  }

  getTotalElements() {
    return this.rawData[PAGE_TOTAL_ELEMENTS] || 0;
  }

  getTotalPages() {
    return this.rawData[PAGE_TOTAL_PAGES] || 0;
  }

  getRawData() {
    return this.rawData;
  }
}

export default {Page};
